import React, { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import { currentDomain, currentPath } from "../Index"
import { promotionsData } from "../data/PromotionData"
import { useNavigate } from "react-router-dom"
import useAppPromotionTheme from "../hooks/useAppPromotionTheme"

export default function WorldCupChampRush({ isLightMode }) {
  const isAppPromo = useAppPromotionTheme(isLightMode)
  const data = promotionsData.find(
    (promo) => promo.title === "World Cup Champ Rush"
  )
  const [isMobile, setIsMobile] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  useEffect(() => {
    if (!data) {
      navigate("/not-found")
    }
  }, [data, navigate])

  if (!data) return null

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>World Cup Champ Rush</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a
                href={
                  isAppPromo
                    ? "/promotion/".replace("/promotion", "/app-promotion")
                    : "/promotion/"
                }
              >
                Promotions
              </a>
              / <span>{data.title}</span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH${data.title}`}
              />
              <div className="promotion-tnc-content">
                <div className="promotion-tnc-info">
                  <div
                    className={`promotion-indication-message ${data.promotionMessage.class}`}
                  >
                    {data.promotionMessage.text}
                  </div>
                  <h1>World Cup Champ Rush</h1>
                  <h2>Celebrate the World Cup Glory</h2>
                  <div className="promotion-tnc-period">
                    <strong> Event Period: </strong>
                    <span> June 12 (16:00) - June 28 (15:00), 2026 </span>
                  </div>
                </div>
                <div className="promotion-tnc-mechanic-content">
                  <strong>Road to Glory</strong>
                  <ul>
                    <li>
                      During the FIFA World Cup period, players can enter the
                      <strong className="highlight"> Road to Glory </strong> H5
                      Event Lobby and participate in an exciting tournament
                      challenge.
                    </li>
                    <li>
                      Choose your favourite national team and begin your World
                      Cup journey. Progress from the Group Stage all the way to
                      the Grand Final and compete for the ultimate championship
                      glory!
                    </li>
                  </ul>

                  <div className="table-wrapper">
                    <table
                      className="promotion-tnc-table"
                      style={{ minWidth: "0" }}
                    >
                      <thead>
                        <tr>
                          <th colSpan={2}>
                            Players will progress through the following stages
                          </th>
                        </tr>
                        <tr>
                          <th>Stage</th>
                          <th>Date / Time</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr>
                          <td>Group Stage</td>
                          <td>June 12 (16:00) - June 28 (15:00)</td>
                        </tr>
                        <tr>
                          <td>Round of 32</td>
                          <td>June 28 (16:00) - July 4 (15:00)</td>
                        </tr>
                        <tr>
                          <td>Round of 16</td>
                          <td>July 4 (16:00) - July 8 (15:00)</td>
                        </tr>
                        <tr>
                          <td>Quarter Finals</td>
                          <td>July 8 (16:00) - July 12 (15:00)</td>
                        </tr>
                        <tr>
                          <td>Semi Finals</td>
                          <td>July 12 (16:00) - July 16 (15:00)</td>
                        </tr>
                        <tr>
                          <td>Grand Final</td>
                          <td>July 16 (16:00) - July 20 (15:00)</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <strong>How To Participate:</strong>
                  <ul>
                    <li style={{ listStyle: "none" }}>
                      Step 1. Enter the H5 Lobby
                      <ul style={{ marginBottom: "10px" }}>
                        <li style={{ listStyle: "none" }}>
                          Open the Event Lobby and select "Champ Rush" to enter
                          the World Cup Event page.
                        </li>
                      </ul>
                    </li>
                    <li style={{ listStyle: "none" }}>
                      Step 2. Choose your national team.
                      <ul style={{ marginBottom: "10px" }}>
                        <li style={{ listStyle: "none" }}>
                          A total of 48 national teams are available for
                          selection. Once a team is selected, your World Cup
                          journey officially begins.
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <strong>Join Now / Abandon</strong>
                  <ul>
                    Upon entering the event, players can choose:
                    <li>
                      Join Now the World Cup tournament challenge and begin
                      completing event objectives.
                    </li>
                    <li>
                      If abandon, your current tournament progress will be
                      terminated.
                    </li>
                  </ul>

                  <strong>Champion Reward System</strong>
                  <ul>
                    How to Unlock Champion Rewards?
                    <li>
                      During the Champ Rush event, players can unlock different
                      Champion Reward Tiers by accumulating the required
                      turnover.
                    </li>
                    <li>
                      Once a turnover milestone is reached, the corresponding
                      Champion Reward Tier will be unlocked and recorded by the
                      system.
                    </li>
                  </ul>

                  <strong>Win The Champion</strong>
                  <ul>
                    <li>
                      Players must reach the required turnover target and
                      successfully win the Championship (Final Winner)
                    </li>
                    <li>
                      Only after becoming the World Champion will all unlock
                      Champion Rewards become available for claiming.
                    </li>
                  </ul>

                  <strong>How to progress through the tournament</strong>
                  <ul>
                    <li>
                      After joining the event, players must continue spinning
                      and completing event objectives.
                    </li>
                    <li>
                      Once the required conditions are met, a World Cup match
                      will be triggered automatically.
                    </li>
                    <li>
                      Players will then enter the: Football Match Bonus Game.
                      Win matches to continue advancing through the tournament.
                    </li>
                  </ul>

                  <strong>Match Mechanics</strong>
                  <ul>
                    <li>
                      Players will face different national teams throughout the
                      tournament.
                    </li>
                    <li>
                      For every goal scored : Current Reward Multiplier x2.
                    </li>
                    <li>
                      The more goals scored, the higher the multiplier. The
                      higher the multiplier, the greater the rewards.
                    </li>
                  </ul>

                  <strong>Star Rating System</strong>
                  <ul>
                    <li>
                      After every match, players will receive a star rating
                      based on : Goals Scored, Goal Difference & Match Score
                      Margin.
                    </li>
                    <li>
                      The final reward amount will be determined by the player's
                      overall tournament performance and accumulated star
                      ratings.
                    </li>
                    <li>
                      The more goals scored, the higher the multiplier. The
                      higher the multiplier, the greater the rewards.
                    </li>
                    <li>Higher Scores = Higher Star Ratings</li>
                  </ul>

                  <strong>Championship Rewards</strong>
                  <ul>
                    Players who successfully win all 6 matches and become World
                    Champion will receive:
                    <li>Championship Grand Prize</li>
                    <li>Accumulated Star Rating Rewards</li>
                    <li>Jackpot Prize Opportunities</li>
                    <li>Exclusive Tournament Rewards</li>
                  </ul>

                  {!isAppPromo && (
                    <div className="promotion-tnc-cta">
                      <a
                        className="promotion-cta-btn"
                        href="/slots/?provider=VPLUS"
                      >
                        PLAY NOW
                      </a>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
